export default "__VITE_ASSET__fb993bed__"